import React, { PropTypes } from 'react';
import styled from 'styled-components';

const CorporateQuoteContainer = styled.section`
  padding-bottom: 70px;
`;

const CorporateQuote = ({ children }) => (
  <CorporateQuoteContainer>
    {children}
  </CorporateQuoteContainer>
);

CorporateQuote.propTypes = {
  children: PropTypes.object
};

export default CorporateQuote;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/CorporateQuote.js